<template>
    <v-card
        class="mb-3"
        elevation="2"
    >
        <v-card-title
            class="secondary lighten-4 white--text"
        >
            {{ index+1 }}. {{ block.System.SystemName }} / {{ block.BlockName }}

            <v-spacer></v-spacer>

            <v-tooltip v-if="!static" top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs" v-on="on"
                        icon
                        color="secondary"
                        @click="$emit('delete')"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('components.block_card.delete') }}</span>
            </v-tooltip>

        </v-card-title>

        <components-table :units="units"></components-table>

        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <strong><!-- {{ blockPrice | currencyFormat }} --></strong>
        </v-card-actions>
    </v-card>
</template>

<script>
import IconQuantityEmpty from "./IconQuantityEmpty";
import IconQuantityLow from "./IconQuantityLow";
import IconQuantityMedium from "./IconQuantityMedium";
import IconQuantityHi from "./IconQuantityHi";
import ComponentsTable from "./ComponentsTable";

export default {
    name: "BlockCard",

    components: {
        IconQuantityHi,
        IconQuantityMedium,
        IconQuantityLow,
        IconQuantityEmpty,
        ComponentsTable,
    },

    props: {
        block: Object,
        units: Array,
        blockPrice: Number,
        index: Number,
        static: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped>

</style>
